<template>
    <Table
        :ref="ref"
        :class="className"
        :columns="selectionColumns"
        :data="data"
        :model-value="modelValue"
        :height="height"
        @onSelectionChange="onSelect"
        @onRowClick="onRowClick"
    />
</template>

<script>
export default {
    name: "TableCheckboxGroup",
    props: {
        modelValue: {
            type: Array,
            default() {
                return [];
            }
        },

        type: {
            type: String,
            default: "table"
        },

        checkboxWidth: {
            type: Number,
            default: 60
        },

        height: {
            type: String || Number
        },

        columns: {
            type: Array,
            default() {
                return [];
            }
        },

        data: {
            type: Array,
            default() {
                return [];
            }
        },

        disableRowClick: {
            type: Boolean,
            default: false
        }
    },

    emits: ["update:modelValue", "on-selection-change", "on-row-click"],

    computed: {
        className() {
            return `table-checkbox-group table-checkbox-group--${this.type}`;
        },

        selectionColumns() {
            if (!this.columns?.length) {
                return [this.selectionColumn, this.labelColumn];
            }

            if (this.columns[0]?.type !== "selection") {
                return [this.selectionColumn, ...this.columns];
            }

            return this.columns;
        },

        ref() {
            return this.$attrs.ref || "tableCheckboxGroup";
        }
    },

    created() {
        this.selectionColumn = {
            type: "selection",
            width: this.checkboxWidth,
            align: "center"
        };

        this.labelColumn = {
            title: "Label",
            key: "label"
        };
    },

    methods: {
        onRowClick(row, index) {
            if (this.disableRowClick) {
                return;
            }

            if (!row._disabled) {
                this.$refs[this.ref].toggleSelect(index);
            }

            this.$emit("on-row-click", row, index);
        },

        onSelect(value) {
            this.$emit("update:modelValue", value);
            this.$emit("on-selection-change", value);
        }
    }
};
</script>

<style lang="scss">
@use "@style/variables" as *;
.table-checkbox-group--ghost {
    border-color: transparent;

    .ivu-table {
        &::before,
        &::after {
            background-color: inherit;
        }

        th,
        td {
            background-color: inherit;
            border-color: transparent;
            height: 25px;
        }

        table {
            border-color: transparent;
            background-color: inherit;
            tr.ivu-table-row-hover {
                background-color: $grey1;

                td {
                    background-color: $grey1;
                }
            }
        }
    }
}
.table-checkbox-group {
    table {
        tr.ivu-table-row-hover {
            background-color: $grey1;

            td {
                background-color: $grey1;
            }
        }
    }
}
</style>
